module.exports = __webpack_public_path__ + "static/media/delete.8b492885.svg";